import BakeasyTextField, { BakeasyTextFieldProps } from './BakeasyTextField';
import { useState } from 'react';
import { t } from 'i18next';
import _ from 'lodash';
import * as Regex from '../../constants/Regex';

export function Username(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      type="text"
      // name="username"
      name={props?.label ?? t('USERNAME')}
      maxLength={30}
      disabled={props?.disabled ?? false}
      required={props?.required ?? true}
      value={props?.value}
      label={t('USERNAME')}
      regexPattern={Regex.username}
      placeHolder={props?.placeHolder}
      onChange={props?.onChange}
      helperMessage={t('PLEASE_ENTER_VALID_USERNAME')}
    />
  );
}

export function Password(props: BakeasyTextFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = (): void => setShowPassword(!showPassword);

  return (
    <BakeasyTextField
      name="password"
      type={showPassword ? 'text' : 'password'}
      maxLength={30}
      value={props?.value}
      showPassword={showPassword}
      required={props?.required ?? true}
      label={props?.label ? props.label : t('PASSWORD')}
      //placeHolder={t('ENTER') + _.toLower(t('PASSWORD'))}
      placeHolder={props?.placeHolder}
      onChange={props?.onChange}
      onIconClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        handleClickShowPassword();
      }}
      disabled={props?.disabled}
      // helperMessage={t('ENTER_PASSWORD')}
    />
  );
}

export function EmailId(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      type="email"
      //  name="email"
      name={props?.label ?? t('EMAIL_ID')}
      maxLength={50}
      label={props?.label ?? t('EMAIL_ID')}
      regexPattern={Regex.emailId}
      required={props?.required ?? false}
      helperMessage={t('PLEASE_ENTER_VALID_EMAIL')}
    />
  );
}

export function AccountingCode(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={t('ACCOUNTING_CODE')}
      type="text"
      name="accountingCode"
      maxLength={30}
      regexPattern={Regex.accountingCode}
      required={props?.required ?? false}
      helperMessage={t('ENTER_VALID_ACCOUNTG_CODE')}
    />
  );
}

export function Work(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={props?.label ?? t('WORK')}
      type="text"
      name={props?.label ?? t('WORK')}
      required={props?.required ?? false}
      maxLength={20}
      regexPattern={Regex.mobile}
      isWorkNumber={true}
      helperMessage={t('PLEASE_ENTER_VALID_WORK_NUMBER')}
    />
  );
}

export function State(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={props?.label ?? t('STATE')}
      type="text"
      name="supplierState"
      maxLength={props?.maxLength ?? 50}
      regexPattern={Regex.onlyAlphabets}
    />
  );
}

export function Pincode(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      required={props?.required ?? false}
      label={props?.label ?? t('POSTAL_CODE')}
      type="text"
      name="PinCode"
      value={props?.value}
      // maxLength={props?.maxLength ?? 7}
      maxLength={props?.maxLength}
      onChange={props?.onChange}
      // regexPattern={Regex.postCode}
      regexPattern={props?.regexPattern ?? Regex.postCode}
      disabled={props?.disabled}
      helperMessage={props?.helperMessage}
      placeHolder={props?.placeHolder}
    />
  );
}

export function Name(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={props?.label ?? t('NAME')}
      type="text"
      name={props?.label ?? t('NAME')}
      required={props?.required ?? false}
      regexPattern={Regex.name}
      helperMessage={props?.helperMessage}
      placeHolder={props?.placeHolder}
    />
  );
}

export function CompanyName(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={props?.label ?? t('NAME')}
      type="text"
      name="name"
      required={props?.required ?? false}
      regexPattern={Regex.name}
      helperMessage={t('PLEASE_ENTER_COMPANY_NAME')}
    />
  );
}

export function Country(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={props?.label ?? t('COUNTRY')}
      type="text"
      name="supplierCountry"
      regexPattern={Regex.onlyAlphabets}
      maxLength={props?.maxLength ?? 50}
    />
  );
}

export function City(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      // required={true}
      label={props?.label ?? t('CITY')}
      type="text"
      name="city"
      maxLength={props?.maxLength ?? 50}
      regexPattern={Regex.onlyAlphabets}
    />
  );
}

export function Address(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      // required={true}
      label={props?.label ?? t('ADDRESS')}
      type="text"
      name="address"
      maxLength={props?.maxLength ?? 100}
      helperMessage={props?.helperMessage}
      placeHolder={props?.placeHolder}
    />
  );
}

export function Search(props: BakeasyTextFieldProps) {
  function handleIconClick(event: React.MouseEvent<HTMLButtonElement>) {
    if (props.onIconClick) {
      props.onIconClick(event);
    }
  }
  return (
    <BakeasyTextField
      label={t('SEARCH')}
      type="text"
      name="search"
      value={props?.value}
      maxLength={30}
      onChange={props?.onChange}
      onIconClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        handleIconClick(event);
      }}
      onEnterClick={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event?.key === 'Enter' && props?.onEnterClick)
          props?.onEnterClick(event);
      }}
    />
  );
}

export function ParentAddress(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={t('PARENT_ADDRESS')}
      type="text"
      name="parentAddress"
      required={true}
      maxLength={30}
    />
  );
}

export function Mobile(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={t('MOBILE')}
      type="text"
      name="phone"
      required={props?.required ?? false}
      maxLength={14}
      regexPattern={Regex.mobile}
      helperMessage={t('PLEASE_ENTER_VALID_MOBILE')}
      isWorkNumber={true}
    />
  );
}

export function LegalName(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={t('LEGAL_NAME')}
      type="text"
      name="legalName"
      maxLength={props?.maxLength ?? 50}
      regexPattern={Regex.name}
    />
  );
}

export function LastName(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={t('LAST_NAME')}
      type="text"
      name="lastName"
      required={props?.required ?? false}
      maxLength={30}
      regexPattern={Regex.name}
      helperMessage={t('PLEASE_ENTER_VALID_LAST_NAME')}
    />
  );
}

export function FirstName(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={t('FIRST_NAME')}
      type="text"
      name="firstName"
      required={props?.required ?? false}
      maxLength={30}
      regexPattern={Regex.name}
      helperMessage={t('PLEASE_ENTER_VALID_FIRST_NAME')}
    />
  );
}

export function SupplierId(props: BakeasyTextFieldProps) {
  return <BakeasyTextField {...props} label={t('SUPPLIER_ID')} />;
}

export function ParentCity(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={t('PARENT_CITY')}
      type="text"
      name="parentCity"
      maxLength={props?.maxLength ?? 50}
      regexPattern={Regex.onlyAlphabets}
      helperMessage={t('PLEASE_ENTER_VALID_PARENT_CITY')}
    />
  );
}

export function ParentState(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={t('PARENT_STATE')}
      type="text"
      name="parentState"
      maxLength={props?.maxLength ?? 50}
      regexPattern={Regex.onlyAlphabets}
    />
  );
}

export function ParentPincode(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={t('PARENT_POSTAL_CODE')}
      type="text"
      name="PinCode"
      maxLength={props?.maxLength ?? 6}
      regexPattern={Regex.onlyNumeric}
    />
  );
}

export function ParentCountry(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={t('PARENT_COUNTRY')}
      type="text"
      name="parentCountry"
      maxLength={props?.maxLength ?? 50}
      regexPattern={Regex.onlyAlphabets}
    />
  );
}

export function Description(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={t('DESCRIPTION')}
      type="text"
      name="description"
      multiline
      rows={props?.rows ?? 5}
      required={props?.required ?? false}
      maxLength={props?.maxLength ?? 800}
      placeHolder={props?.placeHolder}
    />
  );
}

export function StoreId(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      label={t('STORE_ID')}
      disabled={props?.disabled}
      value={props?.value}
    />
  );
}

export function Number(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      name="number"
      maxLength={props?.maxLength ?? 2}
      //placeHolder={t('ENTER') + t(props?.label ?? '')}
      regexPattern={Regex.onlyNumeric}
    />
  );
}
export function DeActivate(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={t('TYPE_DEACTIVATE_HERE')}
      name="deactivate"
      maxLength={10}
      fullWidth={true}
      regexPattern={Regex.onlyAlphabets}
    />
  );
}
export function ReActivate(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      required={true}
      label={t('TYPE_REACTIVATE_HERE')}
      name="reactivate"
      maxLength={10}
      fullWidth={true}
      regexPattern={Regex.onlyAlphabets}
    />
  );
}
// export function MessageTo(props: BakeasyTextFieldProps) {
//   return (
//     <BakeasyTextField
//       {...props}
//       label={t('TO')}
//       placeHolder={t('ENTER') + t('NAME')}
//       type="text"
//       name="name"
//       required={true}
//       maxLength={30}
//     />
//   );
// }

export function Subject(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={t('SUBJECT')}
      type="text"
      name="subject"
      required={props?.required ?? true}
      maxLength={50}
      regexPattern={Regex.msgSubject}
      disabled={props?.disabled ?? false}
      helperMessage={t('PLEASE_ENTER_VALID_SUBJECT')}
    />
  );
}

// export function ProductId(props: BakeasyTextFieldProps) {
//   return (
//     <BakeasyTextField
//       {...props}
//       label={t('PRODUCT_ID')}
//       placeHolder={t('ENTER') + t(props?.label ?? '')}
//     />
//   );
// }

// export function ProductName(props: BakeasyTextFieldProps) {
//   return (
//     <BakeasyTextField
//       {...props}
//       label={props?.label ?? t('PRODUCT_NAME')}
//       placeHolder={t('ENTER') + t(props?.label ?? '')}
//       type="text"
//       name="name"
//       required={props?.required ?? true}
//       maxLength={30}
//       regexPattern={Regex.name}
//       disabled={props?.disabled ?? false}
//     />
//   );
// }

// export function RetailPrice(props: BakeasyTextFieldProps) {
//   return (
//     <BakeasyTextField
//       {...props}
//       required={true}
//       label={t('RETAIL_PRICE')}
//       placeHolder={t('ENTER') + t(props?.label ?? '')}
//       type="text"
//       name="retailPrice"
//       maxLength={props?.maxLength ?? 6}
//       regexPattern={Regex.onlyNumeric}
//     />
//   );
// }

// export function GeneralProductCost(props: BakeasyTextFieldProps) {
//   return (
//     <BakeasyTextField
//       {...props}
//       required={true}
//       label={t('GENERAL_PRODUCT_COST')}
//       placeHolder={t('ENTER') + t(props?.label ?? '')}
//       type="text"
//       name="productCost"
//       maxLength={props?.maxLength ?? 6}
//       regexPattern={Regex.onlyNumeric}
//     />
//   );
// }

export function ReplyMessage(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      // label={t('ENTER_MESSAGE')}
      type="text"
      name="replymsg"
      maxLength={500}
    />
  );
}

export function Tax1(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={props?.label ?? t('ADMIN_TAX1')}
      type="text"
      // name="tax"
      name={props?.label ?? t('ADMIN_TAX1')}
      required={props?.required ?? false}
      maxLength={20}
      regexPattern={Regex.alphaNumericTaxWithDecimalPoint}
      helperMessage={t('PLEASE_ENTER_ADMIN_TAX1')}
    />
  );
}

export function Tax2(props: BakeasyTextFieldProps) {
  return (
    <BakeasyTextField
      {...props}
      label={props?.label ?? t('ADMIN_TAX2')}
      type="text"
      //name="tax"
      name={props?.label ?? t('ADMIN_TAX2')}
      required={props?.required ?? false}
      maxLength={20}
      regexPattern={Regex.alphaNumericTaxWithDecimalPoint}
      helperMessage={t('PLEASE_ENTER_ADMIN_TAX2')}
    />
  );
}
